import { professionalMap } from "./professional";
import { timestampsMap } from "./timestamps";

export const lastAppointmentMap: GenericObject = {
	atendimento_id: "attendanceId",
	diagnostico_medico: "medicalDiagnosis",
	conduta: "conduct",
	tempo_obs: "observationTime",
	data_hora: "dateTime",
	user_id: "userId",
	anamnese: "anamnesis",
	exame_fisico: "physicalExam",
	hipotese_diagnostica: "diagnosticHypothesis",
	descricao_conduta: "conductDescription",
	data_hora_finalizacao: "finishDateTime",
	tipo_consulta: "consultationType",
	setor_id: "departmentId",
	telemed_hash: "telemedHash",
	data_hora_final: "finalDateTime",
	professional: professionalMap,
	...timestampsMap,
};
